import React, { Component } from 'react';
import { Flex, Link, Button } from "../../components";
import vars from "../../vars";
import styled from 'styled-components';

const QuestionsOverview = styled.div`
  display: grid;
  grid-template-columns: repeat(5, ${({gridSize})=> gridSize ? gridSize + 'px' : '60px'});
  grid-gap: 0.7em 0;
  margin: 10px;
  justify-items: center;
  text-align: center;
  
`;
const Hex = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 300 300" >
    <polygon points="300,150 225,280 75,280 0,150 75,20 225,20" />
  </svg>
);

const Hexagon = styled(Flex)`
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 3em;
    height: 3em;
    cursor: pointer;
    text-decoration: none;
    span {
      color: #000;
      z-index: 1;
    }
  }

  svg {
    position: absolute;
    fill: white;
    width: 100%;
    height: 100%;
    polygon {
      stroke: #d6d4d4;
      stroke-width: 10px;
      transition: all 0.3s esae;
      border: 1px solid black;
    }
    transition: all 0.3s esae;
    // border: 1px solid black;
  }
`;

const TestSummary = styled.div`
  text-align: center;
  border: 1px transparent;
  border-radius: 8px;
  padding: 20px 10px;
  background-color: #f6f6f6e3;
  margin: 20px;
  align-items: center;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .5);
  margin-top: 10px;
  
`
const ReportHeading = styled.h4`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: black;
  margin: auto; 
  padding-left: 10px;
  padding-bottom: 10px;
`

const Heading = styled.h4`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: black;
  margin: auto; 
  padding-left: 10px;
`

const SecondaryHeading = styled.p`
  text-align: center;
  font-size: 14px;
  color: #827e7e;
  margin-bottom: 25px;
`

class PracticeTestSummmary extends Component {
  render() {
    let {response , tid,answers, questions, practiceResultsPath, search} = this.props;
    let correct = !tid ? response.correct_questions_count : response.correct_answered_count 
    let total = response.total_questions_count 
    let unanswered = !tid ? response.unanswered_questions_count : response.unanswered_count
    let wrong = !tid ? response.wrong_answered : response.wrong_answered_count
    let score = Math.round(correct / total * 100);
    console.log(score)
    // score = 80
    const sqSize = 160;
    const strokeWidth = 28;
    const radius = (sqSize - strokeWidth) / 2;
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    let Description = score > 85 ? 'Congratulations on your outstanding performance' : score < 85 && score > 70 ? 'Something here ' : 'Congratulations on your performance.';
    const dashArray = radius * Math.PI * 2;
    const dashOffset = dashArray - dashArray * score / 100;
    let windowSize = window.innerWidth;
    let boxWidth = (windowSize - 40 )/3;
    let timeArray = 0;
    let questionsLength = questions.length
    let answersForTime = answers || questions
    for (let i = 0; i < questionsLength; i++) {
      let timeTaken = 0
      let timeTakenArray
      if (!Array.isArray(answersForTime[i]['timetaken'])) {
        timeTakenArray = JSON.parse(answersForTime[i]['timetaken'])
      } else {
        timeTakenArray = answersForTime[i]['timetaken'];
      }
      timeTakenArray.map((item) => {
        timeTaken += +item[2]
      })
      timeArray += timeTaken
      // timeArray.push({'y':timeTaken, 'x': 'Q' + i})
    }
    let minutes = Math.floor(timeArray/60);
    let seconds = timeArray - (minutes*60)
    if(timeArray < 9 ) {
      timeArray = '0' + timeArray
    } 
    if(minutes < 9) {
      minutes = '0' + minutes
    }
    if(seconds < 9) {
      seconds = '0' + seconds
    }
    let timeTaken = timeArray < 60 ? '00:'+ timeArray + ` min` : minutes + `:` + seconds + ` min`
    return (
      <div >
        <div className={score > 30 ? 'confettiDiv' : ''}>
        <TestSummary>
          {score < 30 ? <div className='wronganswerconfetti'></div> : null}
          <ReportHeading>PERFORMANCE REPORT</ReportHeading>
          <div className='boxes'>
            <Flex direction='row' justifyCenter alignCenter justifyAround style={{ margin: score > 30 ? '0' : '0', marginTop: '20px' }}>
              <div className='box correct'>
                <ul className='list'>
                  <li className='listHeading'>{correct}</li>
                  <li className='listValue'>Correct</li>
                </ul>
              </div>
              <div className='box incorrect'>
                <ul className='list'>
                  <li className='listHeading'>{wrong}</li>
                  <li className='listValue'>Incorrect</li>
                </ul>
              </div>
              <div className='box unanswered'>
                <ul className='list'>
                  <li className='listHeading'>{unanswered}</li>
                  <li className='listValue'>Unanswered</li>
                </ul>
              </div>
            </Flex>
          </div>
          <svg
            width={`${sqSize}`}
            height={`${sqSize}`}
            viewBox={viewBox}>
            <defs>
              <linearGradient id="myGradient" gradientTransform="rotate(0)">
                <stop offset="0%" stop-color="#8896de" />
                <stop offset="100%" stop-color="#3F51B5" />
              </linearGradient>
            </defs>
            <circle
              className="circle-background"
              cx={sqSize / 2}
              cy={sqSize / 2}
              r={radius}
              strokeWidth={`${strokeWidth}px`} />
            <circle
              className="circle-progress"
              cx={sqSize / 2}
              cy={sqSize / 2}
              r={radius}
              strokeWidth={`${strokeWidth}`}
              // Start progress marker at 12 O'Clock
              transform={`rotate(90 ${sqSize/2} ${sqSize/2})`}
              style={{
                strokeDasharray: dashArray,
                strokeDashoffset: dashOffset
              }} />
            <text
              className="circle-text"
              x="50%"
              y="50%"
              dy=".3em"
              textAnchor="middle">
              {`${score}%`}
            </text>
          </svg>

          <p className='reportDetails'>You have answered <span className='commentNumber'>{correct}</span> out of <span className='commentNumber'>{total}</span> questions correctly in <span className='commentNumber'>{timeTaken}</span></p>
        </TestSummary>
        </div>
        
        <div className='questions'>
          <Heading>QUESTION WISE ANALYSIS</Heading>
          <SecondaryHeading>Know what have you answered wrong</SecondaryHeading>
          <QuestionsOverview gridSize= {(windowSize -40)/5}>
            {questions.map(({ id }, i) => {
              let is_correct = answers ? (questions[i].correct_option_id == answers[i].question_option_id ? true : false) : (questions[i].correctly_answered === 1 ? true : false)
              return <Hexagon
                key={id}
                center
                // green={is_correct}
                // red={!is_correct}
                // onClick={() => this.props.viewQuestion(i)}
              >
                <Link to={`${practiceResultsPath}${i}${search}`}>
                  <Hex />
                  <span style = {{ fontSize: '20px',fontWeight: '600', color: is_correct ? 'green' : 'red'}}>{i + 1}</span>
                </Link>
              </Hexagon>
            })}
          </QuestionsOverview>
          
        </div>
        <style jsx='true' scoped>{`
          .boxes{
            margin: auto;
            text-align: center;
            color: white;
            margin-bottom: 20px;
          }
          .confettiDiv{
            background: url('/images/confetti.svg');
            background-size: cover;
            background-repeat: no-repeat;
            padding: 12px 0;
          }
          .wronganswerconfetti{
            background: url('/images/wronganswerconfetti.svg');
            background-size: contain;
            background-repeat: no-repeat;
            width: 100%;
            margin: auto;
            background-position: center;
            height: 70px;
            margin-bottom: 13px;
            margin-top: -14px;
          }
          .list{
            list-style: none;
            padding: 0;
          }
          .listHeading{
            font-size: 30px;
            font-weight: 600;
            padding-top: 12px;
          }
          .listValue{
            font-size: 12px;
            font-weight: 600;
          }
          .box{
            margin-right: 5px;
            padding: 0px 10px;
            width: ${boxWidth}px;
            border-radius: 10px;
          }
          .correct{
            background-color: #3F51B5;
            background-image: linear-gradient(to right, #3F51B5, #8b9bf7);
          }
          .incorrect{
            margin-left: 5px;
            background-color: #673AB7;
            background-image: linear-gradient(to right, #673AB7, #ac8be6);
          }
          .unanswered{
            padding: 0px 0px;
            margin-left: 5px;
            margin-right: 0;
            background-color: #bbb;
            background-image: linear-gradient(to right, #636363, #d0cdcd);
          }
          .reportDetails{
            text-align: left;
            font-size: 16px;
            margin-left: 10px;
            padding-top: 20px;
          }
          .commentNumber{
            font-weight: 600;
          }

          .questions{
            margin: 10px;
            margin-top: 20px;
            padding: 20px 5px 20px 5px;
            border-radius: 5px;
          }

          .circle-background,
          .circle-progress {
            fill: none;
          }

          .circle-background {
            stroke: #e6e6e6;
          }

          .circle-progress {
            // stroke: linear-gradient(#3F51B5, violet); 
            stroke: url(#myGradient);
            stroke-linecap: round;
            stroke-linejoin: round;
          }

          .circle-text {
            font-size: 2.4em;
            font-weight: 600;
            fill: #3F51B5;
          }
        
        
        `}

        </style>
      </div>
    )
  }
}

export default PracticeTestSummmary;